import {get, values} from '@servicenow/ui-internal';

/**
 * Gets a list of channel ids and serialized graphql subscriptions from a given subscription query result.
 *
 * @private
 * @method getChannelsFromSubscriptionQuery
 * @param {Object} data Subscription query results.
 * @returns {Array} Object containing channel id and serialized graphql subscription for AMB.
 */
export default function getChannelsFromSubscriptionQuery(data) {
	const items = values(get(data, 'GlideRecord_Subscription'));
	const channels = [];
	const {length: itemsLength} = items;

	for (let i = 0; i < itemsLength; i++) {
		const item = items[i];
		const channelId = get(item, '_subscription.subscription_channel');
		const serializedSubscription = get(item, '_subscription.serialized_subscription');

		if (channelId && serializedSubscription) channels.push({channelId, serializedSubscription});
	}

	return channels;
}
